import Marquee from "react-fast-marquee";

const Item = ({ children }) => (
    <span className="inline-flex items-center gap-8 px-8 font-display text-[10vw] md:text-[7vw] font-black uppercase tracking-tighter leading-none">
        {children}
        <span className="text-[color:var(--brand-blue)]">✱</span>
    </span>
);

export default function MarqueeStrip() {
    return (
        <section data-testid="marquee-strip" className="relative overflow-hidden bg-[color:var(--surface-dark)] text-white py-10 md:py-14 border-y border-white/10">
            <Marquee gradient={false} speed={55} pauseOnHover={false}>
                <Item>Home Renovation</Item>
                <Item>Steven R. Construction LLC</Item>
                <Item>Greenwell Springs · LA</Item>
                <Item>Licensed &amp; Insured</Item>
                <Item>We Treat Your Home As Our Own</Item>
            </Marquee>
        </section>
    );
}
